var base = require('settings/settings');

Vue.component('spark-settings', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/settings.js